import { Box, Typography } from '@mui/material';
import CustomButton from '../inputs/CustomButton';

const DrawerFormSidebar = ({
  sections,
  activeSection,
  onSelect,
  title = 'Secciones',
}) => (
  <Box
    sx={{
      p: { xs: 1, md: 1.5 },
      borderRight: { xs: 0, md: '1px solid' },
      borderBottom: { xs: '1px solid', md: 0 },
      borderColor: 'divider',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: { xs: 'row', md: 'column' },
      gap: 0.75,
      overflowX: { xs: 'auto', md: 'visible' },
      overflowY: 'hidden',
      minWidth: 0,
      flexShrink: 0,
    }}
  >
    <Typography
      variant="caption"
      sx={{
        display: { xs: 'none', md: 'block' },
        color: 'text.secondary',
        fontWeight: 800,
        mb: 0.5,
        textTransform: 'uppercase',
      }}
    >
      {title}
    </Typography>
    {sections.map((section) => {
      const active = activeSection === section.id;
      return (
        <CustomButton
          key={section.id}
          variant={active ? 'base' : 'text'}
          onClick={() => onSelect(section.id)}
          sx={{
            width: { xs: 'auto', md: '100%' },
            minHeight: 42,
            height: 'auto',
            minWidth: { xs: 150, md: 'unset' },
            justifyContent: 'flex-start',
            px: 1.5,
            py: 0,
            fontSize: '0.86rem',
            lineHeight: 1.2,
            boxShadow: 'none',
            border: active ? '1px solid' : '1px solid transparent',
            borderColor: active ? 'primary.main' : 'transparent',
            whiteSpace: 'normal',
            textAlign: 'left',
            overflowWrap: 'anywhere',
            '&:hover': {
              boxShadow: 'none',
              transform: 'none',
            },
            '& .MuiButton-startIcon': {
              flexShrink: 0,
            },
          }}
        >
          {section.label}
        </CustomButton>
      );
    })}
  </Box>
);

export default DrawerFormSidebar;
